<!-- Erstellungsdatum im Format "DD.MM.YYYY" -->
{{ data().createdAt | date:dateFormat }}
